import { Alert } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { messageDataSyncActionAtom } from '../../../atoms/messages';

export function RequestDataSyncMessages() {
  const [dataSyncActionMessage, setDataSyncActionMessage] = useAtom(
    messageDataSyncActionAtom,
  );

  useEffect(() => {
    setDataSyncActionMessage();
  }, []);

  return dataSyncActionMessage ? (
    <Alert type={dataSyncActionMessage.type}>
      {dataSyncActionMessage.text}
    </Alert>
  ) : null;
}

RequestDataSyncMessages.propTypes = {};

export default { RequestDataSyncMessages };
